import { AddFeedbackBody, FeedbackViewModel } from "../models/IFeedback";
import { configWithUserToken } from "./config";

export const submitFeedback = (body: AddFeedbackBody) => {
  return configWithUserToken.post<FeedbackViewModel>("Feedback", body);
};

export const getFeedbackByOrder = (orderId: string) => {
  return configWithUserToken.get<FeedbackViewModel>(`Feedback/order/${orderId}`);
};
